import { IPlayerTag } from '@core/js/hooks/user/store/types';

import { actionTypes } from '@interlayer/js/custom/stores/user/constants';
import * as Types from '@interlayer/js/custom/stores/user/types';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const setWasLoggedIn = (wasLoggedIn: boolean): Action<actionTypes.SET_WAS_LOGGED_IN, boolean> => ({
    type: actionTypes.SET_WAS_LOGGED_IN,
    payload: wasLoggedIn
});

export const setAllPlayerTags = (allPlayerTags: Record<string, IPlayerTag>): Types.ISetAllPlayerTagsAction => ({
    type: actionTypes.SET_ALL_PLAYER_TAGS,
    payload: allPlayerTags
});

export const updatePlayerTags = (playerTags: Record<string, IPlayerTag>): Types.IUpdatePlayerTagsAction => ({
    type: actionTypes.UPDATE_PLAYER_TAGS,
    payload: playerTags
});

export const removePlayerTag = (playerTag: string): Types.IRemovePlayerTagAction => ({
    type: actionTypes.REMOVE_PLAYER_TAG,
    payload: playerTag
});

export const setIsAdaLoaded = (isAdaLoaded: boolean): Types.ISetIsAdaLoadedAction => ({
    type: actionTypes.SET_IS_ADA_LOADED,
    payload: isAdaLoaded
});
